/**
 * ast/core — generic recast/babel AST helpers shared across readers & writers.
 */
import { types } from 'recast';

/**
 * Find a JSX element in the AST by line/col with fuzzy matching.
 * Handles: exact match, 0-based vs 1-based column offset, post-mutation line shifts.
 */
export function findJSXElementInAST(
  ast: any,
  targetLine: number,
  targetCol: number,
  targetType?: string,
): any {
  let exactMatch: any = null;
  let fuzzyMatch: any = null;
  let fuzzyDist = Infinity;

  types.visit(ast, {
    visitJSXElement(path: any) {
      const loc = path.node.openingElement?.loc?.start;
      if (!loc) {
        this.traverse(path);
        return;
      }

      const name = path.node.openingElement?.name?.name || '';
      const lineMatch = loc.line === targetLine;
      const colMatch = loc.column === targetCol || loc.column === targetCol - 1;

      // Exact match
      if (lineMatch && colMatch) {
        exactMatch = path;
      }

      // Fuzzy: same type, closest line within 5
      if (!exactMatch && targetType && name === targetType) {
        const dist = Math.abs(loc.line - targetLine);
        if (dist <= 5 && dist < fuzzyDist) {
          fuzzyDist = dist;
          fuzzyMatch = path;
        }
      }

      this.traverse(path);
    },
  });

  return exactMatch || fuzzyMatch;
}
